class GBETClientEventHelper {

    //static eventListeners = {
    //    "modeLoaded": [], // exchange-sportbook-casino
    //    "registrationDone": [],
    //    "depositDone": [],
    //    "withdrawDone": [],
    //    "balanceChange": [],
    //    "loggedInChange": []
    //};

    static addEventListener(eventName, callback) {
        this.eventListeners = this.eventListeners || {};
        try {
            this.eventListeners[eventName] = this.eventListeners[eventName] || [];
            this.eventListeners[eventName].push(callback);
        } catch (ex) {
            console.error(ex.message);
        }
    }

    static addEventListeners(listeners) {
        try {
            for (var listener in listeners) {
                if (Object.prototype.hasOwnProperty.call(listeners, listener)) {
                    this.addEventListener(listener, listeners[listener]);
                }
            }
        } catch (ex) {
            console.error(ex.message);
        }
    }

    static fireDelegate(eventName, params) {
        if (this.eventListeners && this.eventListeners[eventName]) {
            try {
                for (var i = 0; i < this.eventListeners[eventName].length; i++) {
                    this.eventListeners[eventName][i](params);
                }
            } catch (ex) {
                console.error(ex.message);
            }
        }
    }
}

export default GBETClientEventHelper;
